<template>
    <div id="home">
        <!-- <top :topIndex="2"></top> -->
         <!-- <div class="mian" :style="{ height: mianH + 'px' }"></div> -->
        <div class="mian">
            <div id="AIInterlocutor">
                <left></left>
                <right></right>
            </div>

        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/AIInterlocutor/left.vue' //左侧
import right from '@/components/AIInterlocutor/right.vue' //右侧
export default {
    components: {
        top, left, right
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        }
    }
}
</script>

<style scoped>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    /* min-width: 1500px; */
}
#AIInterlocutor{
    width: 100%;
    height: 100vh;
    /* border-radius: 10px; */
    /* margin: 17px !important; */
    display: flex;
    background-color: #fff;
}
</style>